// Generated by Melange

import * as Mapre_web__Bootstrap from "./lib/bootstrap.js";

Mapre_web__Bootstrap.start();
/*  Not a pure module */
